import React, {useEffect, useState} from 'react'
import {Button} from "primereact/button";
import FetchUtil from "../../../../util/FetchUtil";
import ConfigUtil from "../../../../util/ConfigUtil";
import {getTournamentsystem, TOURNAMENTSYSTEMS} from "../../../../constants/tournamentSystems";
import {BEREICH, isShowPlatzierung} from "./bereiche";

const vorhanden = (wert) => wert !== null && wert !== undefined && wert !== "";

/**
 * Startseite der neuen Ansicht. Je nach Turnierstatus wird gezeigt, was gerade wichtig ist:
 * vor dem Start die Anmeldung, während des Turniers die laufenden Spiele, danach Podium und Kennzahlen.
 */
export default function UebersichtBereich({tournamentWrapper, liveGames, bereiche, onWechsle}) {

    const t = tournamentWrapper.turnierMain;

    const hatSub = (bereichId, subId) => {
        const bereich = bereiche.find(b => b.id === bereichId);
        return bereich !== undefined && bereich.subs.some(sub => sub.id === subId);
    }

    if (t.tournamentstatus === "neu") {
        return <div className="dhpt-karten">
            {t.turniersystem !== TOURNAMENTSYSTEMS.LIGASPIELTAG.id && <AnmeldungKarte t={t} kannAnmelden={hatSub(BEREICH.TEILNEHMER, "anmeldung")} onWechsle={onWechsle}/>}
            <TerminKarte t={t}/>
            <AustragungsortKarte t={t}/>
        </div>
    }

    if (t.tournamentstatus === "abgeschlossen") {
        return <div className="dhpt-karten">
            {isShowPlatzierung(t) && <PodiumKarte t={t} kannPlatzierung={hatSub(BEREICH.STATISTIK, "platzierung")} onWechsle={onWechsle}/>}
            {t.scoringWithDarthelfer && <KennzahlenKarte tournamentWrapper={tournamentWrapper} onWechsle={onWechsle} kannHighlights={hatSub(BEREICH.STATISTIK, "highlights")}/>}
            <TerminKarte t={t}/>
        </div>
    }

    return <div className="dhpt-karten">
        <AmBoardKarte tournamentWrapper={tournamentWrapper} liveGames={liveGames} kannLive={hatSub(BEREICH.SPIELE, "live")} onWechsle={onWechsle}/>
        <TerminKarte t={t}/>
        <AustragungsortKarte t={t}/>
    </div>
}

function Karte({titel, zusatz, breit, children}) {
    return <section className={"dhpt-karte" + (breit ? " dhpt-karte-breit" : "")}>
        <h3 className="dhpt-karte-titel"><span>{titel}</span>{zusatz && <span className="dhpt-karte-zusatz">{zusatz}</span>}</h3>
        {children}
    </section>
}

function AnmeldungKarte({t, kannAnmelden, onWechsle}) {
    const anzahl = t.tournamentPlayerEntities.length;
    const max = t.maxAnzahlTeilnehmer;
    const frei = vorhanden(max) ? Math.max(max - anzahl, 0) : undefined;

    return <Karte titel="Anmeldung" zusatz={vorhanden(t.anmeldeendeMitUhrzeitString) ? "bis " + t.anmeldeendeMitUhrzeitString : undefined} breit={true}>
        <div className="dhpt-gross">
            {!t.registrationAllowed ? "Anmeldung geschlossen" : frei === undefined ? anzahl + " angemeldet" : frei === 0 ? "Ausgebucht" : frei + (frei === 1 ? " Platz frei" : " Plätze frei")}
        </div>
        <p className="dhpt-hinweis">
            {vorhanden(max) ? anzahl + " von " + max + " Plätzen belegt" : anzahl + " Teilnehmer angemeldet"}
            {t.bezahlung && vorhanden(t.bezahlungBetrag) && " · Startgeld " + t.bezahlungBetrag}
        </p>
        {kannAnmelden && t.registrationAllowed &&
            <Button label="Jetzt anmelden" icon="pi pi-plus" onClick={() => onWechsle(BEREICH.TEILNEHMER, "anmeldung")}/>
        }
    </Karte>
}

function TerminKarte({t}) {
    const system = getTournamentsystem(t.turniersystem);
    return <Karte titel="Turnier">
        <dl className="dhpt-liste">
            {vorhanden(t.beginnMitUhrzeitString) && <><dt>Beginn</dt><dd>{t.beginnMitUhrzeitString}</dd></>}
            {system !== undefined && system !== null && <><dt>System</dt><dd>{system.text}</dd></>}
            <dt>Art</dt><dd>{t.dyp ? "DYP" : t.doppelturnier ? "Doppel" : "Einzel"}</dd>
            <dt>Teilnehmer</dt><dd>{t.tournamentPlayerEntities.length}{vorhanden(t.maxAnzahlTeilnehmer) ? " / " + t.maxAnzahlTeilnehmer : ""}</dd>
        </dl>
    </Karte>
}

function AustragungsortKarte({t}) {
    if (!vorhanden(t.austragungsortBezeichnung) && !vorhanden(t.austragungsortStrasse) && !vorhanden(t.austragungsortOrt)) {
        return null;
    }
    const ortZeile = [t.austragungsortPLZ, t.austragungsortOrt].filter(vorhanden).join(" ");
    return <Karte titel="Austragungsort">
        {vorhanden(t.austragungsortBezeichnung) && <div className="dhpt-fett">{t.austragungsortBezeichnung}</div>}
        {vorhanden(t.austragungsortStrasse) && <div>{t.austragungsortStrasse}</div>}
        {vorhanden(ortZeile) && <div>{ortZeile}</div>}
    </Karte>
}

function AmBoardKarte({tournamentWrapper, liveGames, kannLive, onWechsle}) {
    const laufend = (liveGames || [])
        .filter(game => !game.abgeschlossen)
        .sort((a, b) => String(a.boardName || "").localeCompare(String(b.boardName || ""), "de", {numeric: true}));
    const liveGameIds = laufend.map(game => game.gameId);
    const aufgerufen = (tournamentWrapper.boardGames || []).filter(boardGame => !liveGameIds.includes(boardGame.gameId));

    return <Karte titel="Jetzt am Board" breit={true}
                  zusatz={laufend.length > 0 ? <span className="dhpt-chip dhpt-chip-live">{laufend.length} live</span> : undefined}>
        {laufend.length === 0 && aufgerufen.length === 0 && <p className="dhpt-hinweis">Gerade ist kein Spiel einem Board zugeordnet.</p>}
        {laufend.map(game => <LiveSpiel key={game.gameId} game={game}/>)}
        {aufgerufen.map(boardGame => <div className="dhpt-spiel" key={boardGame.id}>
            <div className="dhpt-board">Board<b>{boardGame.boardBezeichnung}</b></div>
            <div className="dhpt-spiel-text">{vorhanden(boardGame.gameDescription) ? boardGame.gameDescription : "Spiel zugeordnet"}</div>
            <div className="dhpt-hinweis">{boardGame.aufgerufen ? "aufgerufen" : "wartet"}</div>
        </div>)}
        {kannLive && laufend.length > 0 &&
            <Button label="Alle Live-Spiele" icon="pi pi-eye" className="p-button-text dhpt-button-hell" onClick={() => onWechsle(BEREICH.SPIELE, "live")}/>
        }
    </Karte>
}

function LiveSpiel({game}) {
    const mitSets = game.sets !== null && game.sets !== undefined && game.sets > 1;
    const stand1 = mitSets ? game.spieler1Sets : game.spieler1Legs;
    const stand2 = mitSets ? game.spieler2Sets : game.spieler2Legs;
    const status = game.startssoon ? "startet gleich" : undefined;
    return <div className="dhpt-spiel dhpt-spiel-live">
        <div className="dhpt-board">Board<b>{game.boardName || "–"}</b></div>
        <div className="dhpt-spieler">
            <div className={stand1 > stand2 ? "dhpt-fett" : ""}>{game.spieler1Name}</div>
            <div className={stand2 > stand1 ? "dhpt-fett" : ""}>{game.spieler2Name}</div>
            {status && <div className="dhpt-hinweis">{status}</div>}
        </div>
        <div className="dhpt-stand">
            <div>{stand1}<span className="dhpt-rest">{vorhanden(game.spieler1Togo) ? game.spieler1Togo : ""}</span></div>
            <div>{stand2}<span className="dhpt-rest">{vorhanden(game.spieler2Togo) ? game.spieler2Togo : ""}</span></div>
        </div>
    </div>
}

function PodiumKarte({t, kannPlatzierung, onWechsle}) {
    const [platzierungen, setPlatzierungen] = useState(undefined);

    useEffect(() => {
        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.public + "/tournament/platzierung/" + t.id,
            {},
            json => setPlatzierungen(json),
            () => setPlatzierungen([]),
            () => setPlatzierungen([]));
    }, [t.id]);

    if (platzierungen === undefined || platzierungen.length === 0) {
        return null;
    }
    // bei geteilten Plätzen (z.B. zwei Dritte) werden die Namen zusammen angezeigt
    const namen = (platz) => platzierungen.filter(p => p.platz === platz).map(p => p.name);
    const stufe = (platz, klasse) => {
        const n = namen(platz);
        if (n.length === 0) {
            return <div className={"dhpt-podium-stufe " + klasse} style={{visibility: "hidden"}}/>;
        }
        return <div className={"dhpt-podium-stufe " + klasse}>
            <strong>{platz}</strong>
            {n.map(name => <span key={name}>{name}</span>)}
        </div>
    }

    return <Karte titel="Podium" breit={true}>
        <div className="dhpt-podium">
            {stufe(2, "dhpt-p2")}
            {stufe(1, "dhpt-p1")}
            {stufe(3, "dhpt-p3")}
        </div>
        {kannPlatzierung &&
            <Button label="Alle Platzierungen" className="p-button-text dhpt-button-hell" onClick={() => onWechsle(BEREICH.STATISTIK, "platzierung")}/>
        }
    </Karte>
}

function KennzahlenKarte({tournamentWrapper, kannHighlights, onWechsle}) {
    const wrapper = tournamentWrapper.ranglisteWrapper;
    if (wrapper === null || wrapper === undefined) {
        return null;
    }
    const summe = (liste) => (liste || []).reduce((gesamt, eintrag) => gesamt + eintrag.anzahl, 0);
    let hoechstesFinish = undefined;
    for (const eintrag of (wrapper.ranglisteHighfinishes || [])) {
        for (const finish of eintrag.values) {
            const wert = Number(finish.key);
            if (!isNaN(wert) && (hoechstesFinish === undefined || wert > hoechstesFinish)) {
                hoechstesFinish = wert;
            }
        }
    }
    let besterAverage = undefined;
    for (const eintrag of (wrapper.ranglisteAverage || [])) {
        if (besterAverage === undefined || Number(eintrag.average) > Number(besterAverage.average)) {
            besterAverage = eintrag;
        }
    }

    return <Karte titel="Kennzahlen" breit={true}>
        <div className="dhpt-kennzahlen">
            <div className="dhpt-kennzahl"><b>{summe(wrapper.rangliste180er)}</b><small>180er</small></div>
            <div className="dhpt-kennzahl"><b>{summe(wrapper.rangliste171er)}</b><small>171er</small></div>
            <div className="dhpt-kennzahl"><b>{hoechstesFinish !== undefined ? hoechstesFinish : "–"}</b><small>Höchstes Finish</small></div>
            {besterAverage !== undefined &&
                <div className="dhpt-kennzahl"><b>{Number(besterAverage.average).toFixed(2).replace(".", ",")}</b>
                    <small>Bester Average · {getSpielerName(tournamentWrapper, besterAverage.id)}</small></div>
            }
        </div>
        {kannHighlights &&
            <Button label="Alle Highlights" className="p-button-text dhpt-button-hell" onClick={() => onWechsle(BEREICH.STATISTIK, "highlights")}/>
        }
    </Karte>
}

export function getSpielerName(tournamentWrapper, id) {
    for (const turnier of [tournamentWrapper.turnierGruppe, tournamentWrapper.turnierKO, tournamentWrapper.turnierMain]) {
        if (turnier === null || turnier === undefined) {
            continue;
        }
        const spieler = turnier.tournamentPlayerEntities.find(s => s.id === id || s.userId === id || s.doppelpartnerId === id);
        if (spieler !== undefined) {
            return spieler.name;
        }
    }
    return "";
}
